// src/components/PublicationCard.jsx
import { useState } from 'react';
import './PublicationCard.css';

function PublicationCard({ publication }) {
  const {
    date,
    title,
    authors,
    journal,
    pdf,
    doi,
    topic,
    HCI,
    summary,
    honorableMention,
    bestPaper,
  } = publication;

  const hasPDF = pdf && pdf.trim() !== '';
  const hasDOI = doi && doi.trim() !== '';

  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`publication-card ${hovered ? 'hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Award badges */}
      {(bestPaper || honorableMention) && (
        <div className="award-badges">
          {bestPaper && (
            <span className="award-badge best-paper">★ Best Paper</span>
          )}
          {honorableMention && (
            <span className="award-badge honorable-mention">✦ Honorable Mention</span>
          )}
        </div>
      )}

      <div className="details">

        {/* Row 1: year | topic | HCI */}
        <div className="publication-meta">
          <span className="year">{date}</span>
          <span className="topic">{topic}</span>
          <span className="hci">{HCI}</span>
        </div>

        {/* Row 2: title */}
        <div className="title">{title}</div>

        {/* Row 3: authors */}
        <div className="authors">{authors}</div>

        {/* Row 4: journal */}
        <div className="publisher">{journal}</div>

        {/* PDF & DOI Links */}
        {(hasPDF || hasDOI) && (
          <div className="pdf-link">
            {hasPDF && (
              <a href={pdf} target="_blank" rel="noopener noreferrer">
                PDF
              </a>
            )}
            {hasPDF && hasDOI && <span> | </span>}
            {hasDOI && (
              <a href={doi} target="_blank" rel="noopener noreferrer">
                DOI
              </a>
            )}
          </div>
        )}

        {/* Abstract / Summary */}
        {summary && (
          <div className="publication-summary">
            {summary}
          </div>
        )}

      </div>
    </div>
  );
}

export default PublicationCard;
